export default __webpack_public_path__ + "assets/15763a0b65b90db6addf4fbd65f7fcc9.svg";